<template>
  <div class="d-flex align-center justify-center">
    <nuxt-link class="logo-container" @click="useAppMainNavigation().home">
      <img
          :src="logoSrc"
          alt="Logo"
          class="logo-img"
      />
    </nuxt-link>
  </div>
</template>

<script lang="ts" setup>



const appSettings = useUserAppSettingsStore();

const logoSrc = ref(useAppImages().logoLightMain); // Initialize with default logo


watch(
    () => appSettings.appThemeMode,
    (newTheme) => {
      if (newTheme === 'light') {
        logoSrc.value = useAppImages().logoLightMain;
      } else {
        logoSrc.value = useAppImages().logoDarkMain;
      }
    },
    {immediate: true} // Ensure the watcher runs immediately on component mount
);

</script>


<style scoped>
.logo-container {
  display: inline-block; /* Ensures nuxt-link wraps tightly around the image */
  padding: 0; /* No extra padding */
}

.logo-img {
  display: block; /* No inline spacing */
  height: 70px; /* Set a fixed height for the image */
  width: auto; /* Allow width to adjust automatically */
  cursor: pointer; /* Pointer appears only on the image */
}
</style>
